// Older servers reject the complete estimate when one row is incomplete.
export async function loadEstimateQuote(send,items){
  const result=await send(items);
  if(result.ok)return result.data;
  if(result.status!==400||items.length<2)throw new Error(result.data.message||'Could not calculate estimate');
  const rows=[];
  for(const item of items){
    const response=await send([item]);
    if(response.ok)rows.push(...response.data.rows);
    else if(response.status===400)rows.push({packId:String(item.packId),error:response.data.message||'Could not calculate this product',needsInput:true,total:null});
    else throw new Error(response.data.message||'Could not load product prices');
  }
  return {rows,total:rows.some(r=>r.total==null)?null:Math.round(rows.reduce((sum,r)=>sum+r.total,0)*100)/100};
}
